import styled from '@emotion/styled';
import { Col, Row } from 'antd';
import { DeleteOutlined } from '@ant-design/icons';

export const ButtonsContainer = styled(Row)`
  height: 100vh;
  flex-direction: column;
`;

export const NavButtonContainer = styled.div`
  display: flex;
  justify-content: space-between;
  margin: ${props => props.theme.spacing.lg} ${props => props.theme.spacing.regular} ${props => props.theme.spacing.md} ${props => props.theme.spacing.regular};
`;

export const SubMenuItem = styled(Row)`
  color: ${props => props.theme.color.primary};
  cursor: pointer;
  margin-bottom: ${props => props.theme.spacing.regular};
  &:first-of-type {
    margin-top: ${props => props.theme.spacing.xxxl};
  }
`;

export const SubMenuItemContainer = styled(Col)`
  background-color: ${props => (props.isActive ? props.theme.color.secondary : props.theme.color.white)};
  border-radius: 4px 0 0 4px;
  color: ${props => props.theme.color.primary};
  display: flex;
  font-weight: ${props => (props.isActive ? props.theme.fontWeight.bold : props.theme.color.regular)};
  line-height: 40px;
  margin-left: ${props => props.theme.spacing.regular};
  padding-left: ${props => props.theme.spacing.regular};
  height: 40px;
  width: 100%;
`;

export const DeleteButtonContainer = styled(Row)`
  margin-bottom: ${props => props.theme.spacing.xxl};
  margin-left: ${props => props.theme.spacing.regular};
  color: #909090;
  cursor: pointer;

  &:hover {
    color: ${props => props.theme.color.red};
  }
`;

export const DeleteIcon = styled(DeleteOutlined)`
  font-size: 16px;
`;

export const DeleteText = styled.span`
  margin-left: 8px;
  border-bottom: 1px solid #909090;
  padding-bottom: 4px;

  &:hover {
    border-bottom: 1px solid ${props => props.theme.color.red};
  }
`;
